export default __webpack_public_path__ + "static/media/MedBlockLogo.3c0373fa.svg";